import { useRouter } from 'next/router';
import { AcceptInvite } from '../../../../components/AcceptInvite';
import { ApplicationCreate } from '../../../../components/ApplicationCreate';

type QueryProps = {
  listingAlias: string;
  inviteId?: string;
  version?: string;
};
export default function CreateNewApplicationForListingPage() {
  const router = useRouter();
  const { listingAlias, inviteId, version } = router.query as QueryProps;
  return inviteId ? (
    // new invitations will not have an applicationId
    <AcceptInvite listingAlias={listingAlias} inviteId={inviteId} version={version} />
  ) : (
    <ApplicationCreate />
  );
}
